import { type ExpReport } from '@edata-portal/icat-plus-api';

import { CONFIG } from '../config';

export function ReportText({ dataReport }: { dataReport: ExpReport }) {
  const { USER_PORTAL_URL: portalUrl } = CONFIG;
  const { underEmbargo, nbReports, proposal } = dataReport;

  if (nbReports === 0) {
    return (
      <p>
        No report found for {proposal}. Proposers and session participants may
        submit one via the{' '}
        <a href={portalUrl} target="_blank">
          ESRF User Portal
        </a>
        .
      </p>
    );
  }

  if (underEmbargo) {
    if (nbReports === 1) {
      return (
        <p>
          The report for {proposal} is confidential until the end of the data
          embargo period. Until then, it is only accessible to the proposers and
          session participants via the
          <a href={portalUrl} target="_blank">
            ESRF User Portal
          </a>
          .
        </p>
      );
    }

    return (
      <p>
        The reports for {proposal} are confidential until the end of the data
        embargo period. Until then, they are only accessible to the proposers
        and session participants via the
        <a href={portalUrl} target="_blank">
          ESRF User Portal
        </a>
        .
      </p>
    );
  }

  if (nbReports === 1) {
    return (
      <p className="mb-2">
        <b>One</b> report has been found for {proposal}:
      </p>
    );
  }

  return (
    <p className="mb-2">
      In total, <b>{nbReports}</b> reports have been found for {proposal}:
    </p>
  );
}
